import { getUserAgent } from './get-user-agent';
import { isAndroid } from './is-android';
import { isMobile } from './is-mobile';
import { isSafari } from './is-safari';
/**
 * 判断是否ipad默认浏览器
 * @returns boolean
 */
export function isIpad(ua) {
    if (ua === void 0) { ua = ''; }
    if (isAndroid(getUserAgent(ua))) {
        return false;
    }
    if (/iPad/i.test(getUserAgent(ua))) {
        return true;
    }
    // 之前发现对于（当时来说）新版iPad，存在其safari浏览器的UA不带iPad字样的情况。
    // 这种情况的一个ua实例是：
    // Mozilla/5.0 (Macintosh;Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko)
    // Version/13.0.1 Safari/605.1.15
    // 实际上我认为这是苹果的bug。对于这种情况，判断如下：
    return !!(isSafari(ua) && !isMobile(ua) && navigator.maxTouchPoints);
}
